<script>

import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import shareBtn from '@/components/shareBtn';

import moveTextHover from '@/components/moveTextHover';
import hoverDesign from '@/components/hoverDesign';

import setMetaUtil from '@/util/setMetaUtil';

export default {
  name: Constants.ROUTER.DISTRIBUTION,
  components: {
    commonFooter,
    commonNav,
    shareBtn,
    moveTextHover,
    hoverDesign,
  },
  data() {
    return {
      ready: false,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
      targetData: {},
    };
  },
  created() {  
    setMetaUtil.setMeta(this, document,
        `${this.$i18n.messages.ja.message.distribution.pageName
        } - ${this.$i18n.messages.ja.message.bandName}`,
        `${this.$i18n.messages.ja.message.distribution.description}`,
      );
    this.targetData = Constants.DISTRIBUTION;

    document.dispatchEvent(new Event('custom-render-trigger'));

    window.onscroll = () => { this.onscroll(); }
    window.onresize = () => { this.onscroll(); }
    this.onscroll();

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    moveToCautionsToDlSale() {
      this.$router.push({ name: Constants.ROUTER.ABOUTSITE });
    },
    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },

    openTwitter() { window.open(Constants.SNS.TWITTER, '_blank'); },
    openYoutube() { window.open(Constants.SNS.YOUTUBE, '_blank'); },
    openInstagram() { window.open(Constants.SNS.INSTAGRAM, '_blank'); },
    openBluesky() { window.open(Constants.SNS.BLUESKY, '_blank'); },
    openFacebook() { window.open(Constants.SNS.FACEBOOK, '_blank'); },
  }
};
</script>

<template>
  <div class="view-distribution page" :class="ready ? 'is-ready' : ''">
    <common-nav/>
    <div id="contents-main" :style="{'min-height': windowHeight + 'px'}">
      <div class="album-title">{{$t(`message.distribution.pageName`)}} - {{$t(`message.bandName`)}}</div>

      <!-- ストリーミング -->
      <div class="contents-container" v-if="targetData.DISTRIBUTION.length > 0">
        <div class="title">{{$t('message.distribution.streaming')}}</div>
        <div v-for="shop in targetData.DISTRIBUTION" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>
      </div>

      <!-- 委託 -->
      <div class="contents-container" v-if="targetData.SHOP.length > 0">
        <div class="title">{{$t('message.discography.sale')}}</div>
        <div v-for="shop in targetData.SHOP" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>
      </div>

      <!-- DL -->
      <div class="contents-container" v-if="targetData.DL.length > 0">
        <div class="title">{{$t('message.discography.dlSale')}}</div>
        <div v-for="shop in targetData.DL" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>

        <div class="caution" @click="moveToCautionsToDlSale">
          <move-text-hover :target-text="$t('message.distribution.cautionsToDlSale')" />
        </div>
      </div>

      <div class="sns-container" :style="{'height': windowHeight + 'px'}">
        <div class="is-sns-link twitter" @click="openTwitter" :title="$t('message.snsName.twitter')"></div>
        <div class="is-sns-link youTube" @click="openYoutube" :title="$t('message.snsName.youTube')"></div>
        <div class="is-sns-link instagram" @click="openInstagram" :title="$t('message.snsName.instagram')"></div>
        <div class="is-sns-link facebook" @click="openFacebook" :title="$t('message.snsName.faceBook')"></div>
        <div class="is-sns-link bluesky" @click="openBluesky" :title="$t('message.snsName.bluesky')"></div>
      </div>

    </div>
    <common-footer/>
    <share-btn :is-fixed="true"/>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .page {
    position: relative;
    #contents-main {
      position: relative;
      padding-top: $commonNavHeight;
      padding-top: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      // 中央寄せ
      justify-content: center;
      align-items: center;
      .album-title {
        font-size: 1.2em;
        margin-bottom: 30px;
      }
      .contents-container {
        margin-bottom: 50px;
        .banner200x40 {
          position: relative;
          margin: 20px auto 0 auto;
          transition: 0.1s ease-out;
          &:hover {
            transform: scale(1.1);
          }
        }
        .text {
          font-size: 0.7em;
        }
        .caution {
          margin-top: 30px;
        }
      }
      .sns-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 50px;
        padding: calc($commonNavHeight * 2) 0;
        display: flex;
        flex-flow: column;
        justify-content:space-around;
        .is-sns-link {
          width: 40px;
          height: 40px;
          margin-left: 10px;
          cursor: pointer;
          @include bgCenter;
          transform: scale(1);
          transition: 0.1s ease-out;
          &.twitter {background-image: url(../assets/img/sns/twitter.svg);}
          &.instagram {background-image: url(../assets/img/sns/instagram.svg);}
          &.youTube {background-image: url(../assets/img/sns/youTube.svg);}
          &.bluesky {background-image: url(../assets/img/sns/bluesky.svg);}
          &.facebook {background-image: url(../assets/img/sns/facebook.svg);}
          &:hover {
            transform: scale(1.2) rotate(10deg) ;
          }
          &.is-hidden {
            display: none;
          }
        }
      }
      
    }
  }
</style>
